import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderReturnHolyLand from "../../../../src/content/return-holy-land/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderReturnHolyLand,
  React
};